/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:48:32                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 16:31:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * LanguageListItem: Display type list item
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import AddressDisplay from "../address/AddressDisplay";
import ZonesAdminActions from "../../../views/super-admin/views/settings/tabs/zones/ZonesAdminActions";
/***/

/**
* LanguageListItem: Display type list item
* @param type - Language data
* @param onClick - On click event
* @param isLast - Is last item 
*/
export default function ZoneListItem({
  zone,
  onClick,
  onChange,
  isLast = false
}: {
  zone: EasyTech.Zone,
  onClick?: () => void,
  onChange: () => void,
  isLast?: boolean
}) {
  return (
    <tr className={`page-list-item ${isLast && "last"}`} onClick={() => onClick && onClick()}>
      <td>
        <div className="flex gap-2 items-center">
          <AddressDisplay address={zone.address}/>
        </div>
      </td>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{zone.radius}</Typography>
        </div>
      </td>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{zone.type}</Typography>
        </div>
      </td>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{zone.enabled ? "Yes" : "No"}</Typography>
        </div>
      </td>
      <td><ZonesAdminActions zone={zone} onChange={onChange} /></td>
    </tr>
  );
}
/***/
